import { MitarbeiterLevel } from '@/types/service-response'
import moment from 'moment'
import { EmployeeDepartment } from '@/model/settings/EmployeeDepartment'

export class EmployeeSecurityLevel {
  public constructor (
    readonly ID: number,
    readonly PersonalNummer: string | null,
    readonly Kurzzeichen: string | null,
    readonly Vorname: string | null,
    readonly Name: string | null,
    readonly Anmeldungen: number,
    readonly PasswortBis: string | null,
    readonly ProfitcenterBezeichnung: string | null,
    readonly AbteilungBezeichnung: string | null,
    readonly SecurityRolle: number,
    readonly SecurityRollenBezeichnung: string | null,
    readonly UserDepartments: EmployeeDepartment[]
  ) {}

  static createFromResponse (responseData: MitarbeiterLevel[]): Array<EmployeeSecurityLevel> {
    let result: Array<EmployeeSecurityLevel> = []
    if (responseData) {
      result = responseData.map((item: MitarbeiterLevel) => {
        const formattedDate = item.PasswortBis ? moment(item.PasswortBis).format('DD.MM.YYYY') : item.PasswortBis
        return new EmployeeSecurityLevel(
          item.ID,
          item.PersonalNummer,
          item.Kurzzeichen,
          item.Vorname,
          item.Name,
          item.Anmeldungen,
          formattedDate,
          item.ProfitcenterBezeichnung,
          item.AbteilungBezeichnung,
          item.SecurityRolle,
          item.SecurityRollenBezeichnung,
          item.UserDepartments ? EmployeeDepartment.createFromResponse(item.UserDepartments) : []
        )
      })
    }
    return result
  }
}
